import { BlockProps } from "./blocks/registry";
import { Heading } from "../design-system/atoms/Heading";
import Icon from "../design-system/atoms/Icon";
import { Button } from "../design-system/atoms/Button";
import Link from "next/link";
import { Paragraph } from "../design-system/atoms/Paragraph";
import { resolveLegacyLink } from "../utils/linkUtils";

export default function BienEtre({ data }: BlockProps) {
    if (!data) return null;

    return (
        <section className="py-16 lms-container bg-white" key={data.id}>

            <div className="text-center mb-12">
                <Heading as="h2" className="lg:text-5xl text-4xl font-bold text-text">
                    {data.titre.split(" ").slice(0, -1).join(" ")}{" "}
                    <span className="text-secondary">
                        {data.titre.split(" ").slice(-1)}
                    </span>
                </Heading>
                {data.descr && (
                    <Paragraph className="mt-4 text-lg text-text">{data.descr}</Paragraph>
                )}
            </div>

            {/* Grid des menus centrée */}
            <div className="grid gap-8 grid-cols-2 lg:grid-cols-4 max-w-7xl mx-auto justify-items-center">
                {data.typeMenu.map((card: any, i: number) => (
                    <article
                        key={i}
                        className="flex h-full flex-col items-center rounded-2xl bg-white px-6 py-10 text-center transition duration-300 border border-transparent hover:border-gray-200 hover:shadow-[0px_8px_30px_rgba(0,0,0,0.1)]"
                    >

                        <Icon
                            src={card.icon.url}
                            alt={card.iconAlt ?? card.titre}
                            className="h-24 w-24 object-contain text-white"
                        />


                        <h3 className="mt-6 text-xl font-bold text-gray-800">
                            {card.titre}
                        </h3>


                        <p className="mt-3 flex-1 text-sm leading-relaxed text-gray-600">
                            {card.descr}
                        </p>

                        <Link href={resolveLegacyLink(card.cta.link)} >
                            <Button className="mt-6 w-fit rounded-3px border border-gray-300 bg-white px-6 py-3 text-xs font-semibold uppercase tracking-wide text-gray-700 hover:bg-primaryGreen hover:text-white transition">
                                {card.cta.text}
                            </Button>
                        </Link>

                    </article>
                ))}
            </div>
        </section>
    );
}